import { ExtendedBrightcovePlayer } from '../../types';

const VOLUME_STEP = 0.05;
function increaseVolume(v: number): number {
  const nextVolume = Math.min(v + VOLUME_STEP, 1);
  return nextVolume;
}
function decreaseVolume(v: number): number {
  const nextVolume = Math.max(v - VOLUME_STEP, 0);

  return nextVolume;
}

export function addVolumeHotkeys(player: ExtendedBrightcovePlayer): void {
  player.on('keydown', (e: KeyboardEvent) => {
    if (e.key === 'ArrowUp') {
      const currentVolume = player.volume();
      player.volume(increaseVolume(currentVolume));
    }
    if (e.key === 'ArrowDown') {
      const currentVolume = player.volume();
      player.volume(decreaseVolume(currentVolume));
    }
  });
}
